import React from 'react';
import LinearProgress from './LoadingBar.style';

const LoadingBar: React.FC<{ color?: string }> = ({ color = 'primary' }) => (
  <LinearProgress style={{ zIndex: 999 }} aria-label="Loader" color='primary' id={color} />
);

export default LoadingBar;
